import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface LocationConsentDialogProps {
  open: boolean;
  onClose: () => void;
  onAccept: () => void;
}

export function LocationConsentDialog({ open, onClose, onAccept }: LocationConsentDialogProps) {
  const { t } = useTranslation();

  const handleAccept = () => {
    onAccept();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('Location Tracking Consent')}</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <Typography variant="body1" gutterBottom>
            {t('Location tracking helps coordinate search efforts by sharing your position with other users. Your location will be:')}
          </Typography>
          
          <List dense sx={{ mt: 2 }}>
            <ListItem>
              <ListItemText primary={t('• Tracked continuously while enabled')} />
            </ListItem>
            <ListItem>
              <ListItemText primary={t('• Stored on the server')} />
            </ListItem>
            <ListItem>
              <ListItemText primary={t('• Shared with other users in this room')} />
            </ListItem>
            <ListItem>
              <ListItemText primary={t('• Used to coordinate canopy search operations')} />
            </ListItem>
          </List>

          <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
            {t('You can disable tracking at any time by clicking the location button again.')}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          {t('Cancel')}
        </Button>
        <Button 
          onClick={handleAccept} 
          variant="contained" 
          color="primary"
        >
          {t('Accept and Enable Tracking')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}